<template lang="html">
  <div class="demo">
    <h1 v-text="$ml.get('demo.title')"/>
    <p><a href="http://demo.tracking-online.it" target="_blank">{{ $ml.get('demo.atext1') }}</a> {{ $ml.get('demo.text') }} <a href="/contacts">{{ $ml.get('demo.atext2') }}</a></p>
    <b-row>
      <b-col md="12">
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
p a {
  color: #E0161A;
}
p a:hover {
  color: #444;
  text-decoration: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Demo.vue